<template>
  <div>
    <el-backtop></el-backtop>
    <div class="content-row">
      <div class="block">
        <el-carousel height="33rem">
          <el-carousel-item v-for="item in pages" :key="item">
            <el-image class="recommend-img" :src="item.url"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <el-image class="recommend-img" src="/index/static/image/top-main.png"></el-image> -->
    </div>
    <div class="content-row">
        <div style="width:60%;margin-left:18.5;">
            <div class="col-2">
                <div class="content-left=row">
                    <span>导航栏目</span>
                </div>
                <div class="coontent-left-row">
                    <ul>
                        <li>>为什么选择我们</li>
                        <li>>数据中心互联的解决方案</li>
                        <li>>长距离光传输</li>
                    </ul>
                </div>
            </div>
            <div class="col-10">
                <div class="content-left-row">
                    <span>{{title}}</span>
                </div>
                <div v-html="content"></div>
            </div>
        </div>
    </div>
   
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      title:"",
      content:"",
      pages: [
        // {
        //   title: "",
        //   url: "/index/static/image/baner1.jpg"
        // },
        // {
        //   title: "",
        //   url: "/index/static/image/baner2.jpg"
        // },
        // {
        //   title: "slide3",
        //   url: "/index/static/image/baner3.jpg"
        // },
        {
          title: "slide3",
          url: "/index/static/image/baner4.jpg"
        }
      ]
    };
  },
  watch: {},
  mounted() {
    this.view();
  },
  methods: {
    view() {
      this.$axios({
        method: "post",
        url: "/index/catalogue/recently",
        params: {}
      })
        .then(res => {
          this.recently_list = res.data.data;
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "/index/catalogue/good_hot",
        params: {}
      })
        .then(res => {
          this.hot_list = res.data.data;
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "/index/catalogue/good_hot",
        params: {}
      })
        .then(res => {
          this.promotion_list = res.data.data;
        })
        .catch(err => {});
    },
   
  }
};
</script>
<style lang="less" scoped>
body {
  overflow-y: auto;
}
.center-near-row {
  background-image: url("/index/static/image/center-bg.png");
}
.center-promotion-row {
  background-color: #f9f5f0;
}
.center-hot-row {
  background-color: #edf1f5;
}
.center-near-row,
.center-promotion-row,
.center-hot-row {
  margin-bottom: 0;
}
.span-white {
  color: #fff;
}
.recent-left-img {
  float: left;
  margin-left: 18.5%;
  width: 13%;
}
.recent-list-div {
  border: 1px solid lightgray;
  background-color: #fff;
  float: left;
  width: 18%;
  height: 50%;
  margin: 0 1% 1% 1%;
  padding: 1%;
}
.recent-all-list {
  height: 100%;
  width: 50%;
  float: left;
  margin-left: 1%;
}
.div-recent {
  margin: 1% 0 1% 0;
}
.auto-fix-button {
}
.content-left-row {
  margin-bottom: 5%;
}
.top-image {
  // margin-right: 1%;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Detail/index.vue